import popMgr from '@/components/global/popMgr';
const styleMap = {
    standard: () =>
        import(
            /* webpackChunkName: "common/calculator/standard"*/ './standard.vue'
        ),
    template1: () =>
        import(
            /* webpackChunkName: "common/calculator/template1"*/ './template1.vue'
        ),
    template4: () =>
        import(
            /* webpackChunkName: "common/calculator/template4"*/ './template4.vue'
        ),
    broker: () =>
        import(
            /* webpackChunkName: "common/calculator/broker-pop"*/ './broker-pop.vue'
        )
};

const psMap = {};
let calculator = {
    prepare(style) {
        if (!psMap[style]) {
            psMap[style] = styleMap[style]();
            // window.siteAppVm.$options.components['caculator'] = styleMap[style];
        }
        return psMap[style];
    },
    open(data, options = {}, style = 'standard') {
        const vdata = {
            options,
            info: data.info,
            initPayment: data.initPayment,
            onPermonthChange: data.onPermonthChange
        };
        this.prepare(style).then(pop => {
            popMgr.create(pop.default, vdata);
        });
    }
};
export default calculator;
